var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle64ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 88 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M62.941 53h-4.059V43h2.55a2.5 2.5 0 0 1 2.478 2.835L62.941 53ZM25.059 53h4.059V43h-2.55a2.5 2.5 0 0 0-2.478 2.835L25.059 53Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M58.883 53H29.118V43h29.765z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M23.706 53h40.588"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M25.059 7h4.059v10h-2.55a2.5 2.5 0 0 1-2.478-2.835L25.059 7ZM62.941 7h-4.059v10h2.55a2.5 2.5 0 0 0 2.478-2.835L62.941 7Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M29.118 7h29.765v10H29.118z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M64.294 7H23.706"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M82 25v10l-8.274.752A2.5 2.5 0 0 1 71 33.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L82 25Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m80 24 .445.223A2.813 2.813 0 0 1 82 26.738v6.524c0 1.065-.602 2.039-1.555 2.515L80 36"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6 35V25l8.274-.752A2.5 2.5 0 0 1 17 26.738v6.524a2.5 2.5 0 0 1-2.726 2.49L6 35Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8 36-.445-.223A2.813 2.813 0 0 1 6 33.262v-6.524c0-1.065.602-2.039 1.555-2.515L8 24"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M21.001 22.5a1.5 1.5 0 0 1 1.5-1.5h43a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5h-43a1.5 1.5 0 0 1-1.5-1.5v-15Z"
})));
SvgRectangle64ASelected.viewBox = '0 0 88 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle64ASelected);
export default ForwardRef;